class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const AUTOPLAY_DELAY = 3000;
    const AUTOPLAY_SPEED = 500;
    let heroProgressRAF = null;

    // 初回ロード判定（Swiper初期化前に判定が必要）
    const FIRST_LOAD_KEY = 'firstLoadTimestamp';
    const THIRTY_MINUTES = 30 * 60 * 1000;
    const now = Date.now();
    const firstLoadTimestamp = localStorage.getItem(FIRST_LOAD_KEY);
    const isFirstLoad = !firstLoadTimestamp || (now - parseInt(firstLoadTimestamp, 10)) > THIRTY_MINUTES;
    if (isFirstLoad) {
      localStorage.setItem(FIRST_LOAD_KEY, String(now));
    }

    function updateHeroText(swiper) {
      const activeIndex = swiper.realIndex;
      document.querySelectorAll('.js-hero-text').forEach((el) => {
        const isActive = parseInt(el.dataset.index, 10) === activeIndex;
        el.classList.toggle('opacity-0', !isActive);
        el.classList.toggle('opacity-100', isActive);
      });
    }

    const heroSwiper = new Swiper(".js-hero-swiper", {
      loop: true,
      slidesPerView: 1,
      speed: AUTOPLAY_SPEED,
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: AUTOPLAY_DELAY,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,      // 追加: ホバーしても止まらない
        stopOnLastSlide: false,        // 追加: 最後で止まらない
        waitForTransition: false       // 追加: トランジション中もキューしない
      },
      navigation: {
        nextEl: ".js-hero-swiper-next",
        prevEl: ".js-hero-swiper-prev",
      },
      on: {
        slideChangeTransitionEnd(swiper) {
          startHeroProgressAnimation(swiper, 'slideChangeTransitionEnd');
        },
        slideChangeTransitionStart(swiper) {
          updateHeroText(swiper);
        },
        init(swiper) {
          updateHeroText(swiper);
          if (isFirstLoad) {
            swiper.autoplay.stop();
          } else {
            startHeroProgressAnimation(swiper, 'init');
          }
          document.querySelectorAll(".hero-swiper-progress__segment").forEach((segment) => {
            segment.addEventListener("click", () => {
              const index = parseInt(segment.dataset.index, 10);
              swiper.slideToLoop(index);
            });
          });
        },
        slideNextTransitionStart(swiper) {

          if (swiper.activeIndex === swiper.slides.length - 1) {
            $('.hero-swiper-progress__segment-fill').animate({ opacity: 0 }, AUTOPLAY_SPEED);
            setTimeout(() => {
              $('.hero-swiper-progress__segment-fill').css('opacity', '1');
            }, AUTOPLAY_SPEED + 100);
          }
          
        },
      },
    });

    function startHeroProgressAnimation(swiper, type) {
      if (heroProgressRAF) {
        cancelAnimationFrame(heroProgressRAF);
        heroProgressRAF = null;
      }

      const segments = document.querySelectorAll(".hero-swiper-progress__segment-fill");
      const activeIndex = swiper.realIndex;
      const startTime = performance.now();

      const animate = (timestamp) => {
        const elapsed = timestamp - startTime;
        let progress;
        if(type === 'init') {
          progress = Math.min((elapsed / AUTOPLAY_DELAY) * 100, 100);
        } else {
          progress = Math.min((elapsed / (AUTOPLAY_DELAY - AUTOPLAY_SPEED)) * 100, 100);
        }

        segments.forEach((fill, i) => {
          if (i < activeIndex) {
            fill.style.width = "100%";
          } else if (i === activeIndex) {
            fill.style.width = `${progress}%`;
          } else {
            fill.style.width = "0%";
          }
        });

        if (progress < 100) {
          heroProgressRAF = requestAnimationFrame(animate);
        }
      };

      heroProgressRAF = requestAnimationFrame(animate);
    }

    const PC_BREAKPOINT = 768;
    const PC_MIN_SLIDES = 3;
    const SP_MIN_SLIDES = 2;
    const PC_WORKS_NAV_MIN_SLIDES = 4;
    const SP_WORKS_NAV_MIN_SLIDES = 2;

    document.querySelectorAll(".js-product-swiper").forEach((el) => {
      const container = el.closest(".js-product-swiper-container");
      if (!container) return;
      const navWrapper = container.querySelector(".js-product-swiper-nav");
      const count = el.querySelectorAll(".swiper-slide").length;
      if (count === 0) {
        if (navWrapper) navWrapper.style.display = 'none';
        return;
      }

      const isPC = () => window.innerWidth >= PC_BREAKPOINT;
      const wantsSwiper = () => isPC() ? count >= PC_MIN_SLIDES : count >= SP_MIN_SLIDES;

      let swiperInstance = null;
      let swiperActive = null;

      const applyProductSwiper = () => {
        const enable = wantsSwiper();
        if (swiperActive === enable) {
          if (swiperInstance) swiperInstance.update();
          return;
        }
        swiperActive = enable;
        if (!enable) {
          if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
          }
          el.classList.add('is-product-static');
          if (navWrapper) navWrapper.style.display = 'none';
          return;
        }
        el.classList.remove('is-product-static');
        if (navWrapper) navWrapper.style.display = '';
        swiperInstance = new Swiper(el, {
          loop: true,
          slidesPerView: 1.3,
          speed: 500,
          loopAdditionalSlides: 10,
          navigation: {
            nextEl: container.querySelector(".js-product-swiper-next"),
            prevEl: container.querySelector(".js-product-swiper-prev"),
          },
          pagination: {
            el: container.querySelector(".js-product-swiper-pagination"),
            type: "fraction",
          },
          breakpoints: {
            [PC_BREAKPOINT]: {
              slidesPerView: 2,
            },
          },
        });
      };

      applyProductSwiper();
      window.addEventListener('resize', applyProductSwiper);
    });

    // トップバナー: 表示中ブレークポイントのみ初期化（非表示時初期化だとページネーションが壊れる）
    {
      const mqPc = window.matchMedia(`(min-width: ${PC_BREAKPOINT}px)`);
      let bannerSwiperPc = null;
      let bannerSwiperSp = null;

      const destroyBannerSwiper = (instance) => {
        if (!instance) return null;
        instance.destroy(true, true);
        return null;
      };

      const bannerAutoplay = {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };

      const initBannerSwiperPc = () => {
        const el = document.querySelector(".js-banner-swiper-pc");
        const container = el?.closest(".js-banner-swiper-container-pc");
        if (!el || !container) return null;
        return new Swiper(el, {
          slidesPerView: 4,
          spaceBetween: 10,
          speed: 500,
          loop: true,
          loopAdditionalSlides: 4,
          watchOverflow: true,
          autoplay: bannerAutoplay,
          navigation: {
            nextEl: container.querySelector(".js-banner-swiper-next-pc"),
            prevEl: container.querySelector(".js-banner-swiper-prev-pc"),
          },
          pagination: {
            el: container.querySelector(".js-banner-swiper-pagination-pc"),
            clickable: true,
          },
        });
      };

      const initBannerSwiperSp = () => {
        const el = document.querySelector(".js-banner-swiper-sp");
        const container = el?.closest(".js-banner-swiper-container-sp");
        if (!el || !container) return null;
        return new Swiper(el, {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 500,
          loop: true,
          watchOverflow: true,
          autoplay: bannerAutoplay,
          pagination: {
            el: container.querySelector(".js-banner-swiper-pagination-sp"),
            clickable: true,
          },
        });
      };

      const applyBannerSwipers = () => {
        if (mqPc.matches) {
          bannerSwiperSp = destroyBannerSwiper(bannerSwiperSp);
          if (!bannerSwiperPc) {
            bannerSwiperPc = initBannerSwiperPc();
          } else {
            bannerSwiperPc.update();
          }
        } else {
          bannerSwiperPc = destroyBannerSwiper(bannerSwiperPc);
          if (!bannerSwiperSp) {
            bannerSwiperSp = initBannerSwiperSp();
          } else {
            bannerSwiperSp.update();
          }
        }
      };

      applyBannerSwipers();
      mqPc.addEventListener("change", applyBannerSwipers);
    }

    document.querySelectorAll('.js-works-cat-tabs-scroll').forEach((scrollEl) => {
      const progressFill = scrollEl.closest('.js-works-cat-tabs-wrap')?.querySelector('.js-works-cat-tabs-progress-fill');
      if (!progressFill) return;

      const updateCatTabsScrollProgress = () => {
        const maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
        const progress = maxScroll > 0 ? scrollEl.scrollLeft / maxScroll : 1;
        progressFill.style.width = `${Math.min(100, Math.max(0, progress * 100))}%`;
      };

      scrollEl.addEventListener('scroll', updateCatTabsScrollProgress, { passive: true });
      window.addEventListener('resize', updateCatTabsScrollProgress);
      updateCatTabsScrollProgress();
    });

    document.querySelectorAll(".js-works-swiper").forEach((el) => {
      const container = el.closest(".js-works-swiper-container");
      if (!container) return;
      const progressFill = container.querySelector(".js-works-swiper-progress-fill");
      const navWrapper   = container.querySelector(".js-works-swiper-nav");
      const footerEl     = container.querySelector(".js-works-swiper-footer");
      const totalCount = parseInt(el.dataset.count, 10) || el.querySelectorAll(".swiper-slide").length || 0;
      const getVisibleCount = () => el.querySelectorAll(".swiper-slide:not(.is-filtered-out)").length;
      let visibleCount = totalCount;
      container.dataset.worksSlides = visibleCount;

      const isPC = () => window.innerWidth >= PC_BREAKPOINT;

      const wantsSwiper = () => visibleCount > 0 && (
        isPC()
          ? visibleCount >= PC_WORKS_NAV_MIN_SLIDES
          : visibleCount >= SP_MIN_SLIDES
      );

      const shouldShowNav = () => isPC()
        ? visibleCount >= PC_WORKS_NAV_MIN_SLIDES
        : visibleCount >= SP_WORKS_NAV_MIN_SLIDES;

      const updateNav = () => {
        const show = shouldShowNav();
        if (navWrapper) {
          navWrapper.style.display = show ? '' : 'none';
        }
        // ナビ非表示時は 1fr 列にボタンだけが残って横全幅になるのを防ぐ
        if (footerEl) {
          footerEl.classList.toggle('is-nav-hidden', !show);
        }
      };

      const updateWorksProgress = (swiper) => {
        if (!progressFill) return;
        if (visibleCount <= 1) {
          progressFill.style.width = '100%';
          return;
        }
        if (swiper && typeof swiper.progress === 'number') {
          progressFill.style.width = `${Math.min(100, Math.max(0, swiper.progress * 100))}%`;
          return;
        }
        progressFill.style.width = '0%';
      };

      let swiperInstance = null;
      let swiperActive = null;

      const applyWorksPickupSwiper = () => {
        updateNav();
        const enable = wantsSwiper();

        if (swiperActive === enable) {
          if (swiperInstance) {
            swiperInstance.update();
            updateWorksProgress(swiperInstance);
          } else {
            // Swiperを使わない状態でも、バーだけは常に「正しい見た目」にしておく
            updateWorksProgress({ realIndex: 0 });
          }
          return;
        }
        swiperActive = enable;
        if (!enable) {
          if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
          }
          el.classList.add('is-pickup-static');
          updateWorksProgress({ realIndex: 0 });
          return;
        }
        el.classList.remove('is-pickup-static');

        // container配下のナビを都度取得（SP含めインスタンスごとに紐付け）
        const nextEl = container.querySelector(".js-works-swiper-next");
        const prevEl = container.querySelector(".js-works-swiper-prev");

        swiperInstance = new Swiper(el, {
          slidesPerView: 1,
          centeredSlides: false,
          speed: 500,
          ...(nextEl && prevEl
            ? {
                navigation: {
                  nextEl,
                  prevEl,
                },
              }
            : {}),
          breakpoints: {
            [PC_BREAKPOINT]: {
              slidesPerView: 3.3,
            },
          },
          on: {
            init(swiper) {
              updateWorksProgress(swiper);
            },
            slideChangeTransitionStart(swiper) {
              updateWorksProgress(swiper);
            },
            slideChangeTransitionEnd(swiper) {
              updateWorksProgress(swiper);
            },
            progress(swiper, progress) {
              if (!progressFill) return;
              progressFill.style.width = `${Math.min(100, Math.max(0, progress * 100))}%`;
            },
          },
        });
      };

      const tabsEl = container.closest('.c-inner')?.querySelector('.js-works-cat-tabs');
      if (tabsEl) {
        tabsEl.querySelectorAll('.js-works-cat-tab').forEach((tab) => {
          tab.addEventListener('click', () => {
            const category = tab.dataset.category || '';
            tabsEl.querySelectorAll('.js-works-cat-tab').forEach((button) => {
              const isActive = button === tab;
              button.classList.toggle('is-active', isActive);
              button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });

            el.querySelectorAll('.swiper-slide').forEach((slide) => {
              const categories = JSON.parse(slide.dataset.categories || '[]');
              const match = !category || categories.includes(category);
              slide.classList.toggle('is-filtered-out', !match);
            });

            visibleCount = getVisibleCount();
            container.dataset.worksSlides = visibleCount;

            swiperActive = null;
            applyWorksPickupSwiper();
          });
        });
      }

      if (totalCount === 0) return;

      applyWorksPickupSwiper();
      window.addEventListener('resize', applyWorksPickupSwiper);
    });

    // 初回ロード時のGSAPアニメーション
    if (isFirstLoad) {
      const tl = gsap.timeline({
        onStart: () => {
          scrollBan();
        },
        onComplete: () => {
          heroSwiper.autoplay.start();
          startHeroProgressAnimation(heroSwiper);
        },
      });

      tl.set('header, .js-hero, .js-hero-bottom', {
        opacity: 0,
      });

      tl.to('.js-loading-overlay img', {
        opacity: 1,
        duration: 0.3,
        delay: 0.3,
        ease: 'power2.inOut',
        onComplete: () => {
          document.documentElement.classList.remove('is-first-load');
        },
      });
      tl.to('.js-loading-overlay', {
        clipPath: 'inset(100% 0 0 0)',
        duration: 0.5,
        delay: 0.8,
        ease: 'linear',
      });
      tl.to('header, .js-hero, .js-hero-bottom', {
        opacity: 1,
        duration: 0.5,
        delay: 0.5,
        ease: 'power2.inOut',
        onComplete: () => {
          scrollBan();
        },
      });
    } else {
      $('.js-loading-overlay').fadeOut(300);
    }
  }
}
